import {
  TYPE_PDP_AV,
  TYPE_PDP_CENTER,
  TYPE_PDP_NA,
  TYPE_PDP_TOP,
} from 'shared/consts/crosssellWidgets'
import { OFFER_TYPE_SAE } from 'shared/consts/marketplace'
import { LIFESTYLE_PRODUCT } from 'shared/consts/productAttributes'
import {
  PRESCRIPTION_TYPE_TO_PRICE_TYPE,
  PRODUCT_TEMPLATES,
} from 'shared/consts/productTemplates'
import { TENANT_COM } from 'shared/consts/tenants'
import { isMarketplace } from 'shared/experiments/utils/featureFlags'
import { getWid } from 'shared/utils/crosssell'
import { getPriceForType } from 'shared/utils/productTemplateUtils'
import {
  hasFlag,
  isProductAvailable,
  isProductOutOfTrade,
} from 'views/utils/productUtils'

const OUT_OF_SALE_REJECTION_REASON = 'outofsale'

export const getBonus = (prices, prescriptionType) => {
  const price = getPriceForType(
    prices,
    PRESCRIPTION_TYPE_TO_PRICE_TYPE[prescriptionType]
  )

  return price?.bonus ? price.bonus : 0
}

export const shouldRenderCrosssellWidgetForProduct = ({
  type,
  product,
  exception = null,
}) => {
  const { followUpProductCode, stockStatus, flags } = product
  const isProductVariantOutOfTrade = isProductOutOfTrade(stockStatus)
  const isAvailable = isProductAvailable(stockStatus)
  const noSuccessor = isProductVariantOutOfTrade && !followUpProductCode

  const exceptionFlags = exception?.[type]

  if (exceptionFlags && hasFlag(flags, exceptionFlags)) {
    return false
  }

  if (product.rejectionReason === OUT_OF_SALE_REJECTION_REASON) {
    return false
  }

  switch (type) {
    case TYPE_PDP_CENTER:
      return isAvailable
    case TYPE_PDP_NA:
      return !isAvailable && !noSuccessor
    case TYPE_PDP_AV:
      return noSuccessor
    case TYPE_PDP_TOP:
      return isAvailable
    default:
      return false
  }
}

export const getCrosssellWidgetProps = ({
  shopConfig,
  isAllVariantsNL,
  category = '',
  isMp = false,
}) => {
  const vicFullWidth = 6
  const vicDefault = 3
  const wid = isAllVariantsNL ? TYPE_PDP_NA : TYPE_PDP_AV
  const cid = isAllVariantsNL ? '' : category
  const visibleItemCount = isAllVariantsNL ? vicFullWidth : vicDefault

  return {
    wid: getWid(isMp, shopConfig?.crosssell?.widgets[wid]),
    visibleItemCount,
    'ctxcat.cid': cid,
  }
}

export const hasSaeVariant = (experiments, tenant, productVariants) => {
  // If not marketplace set flag always on true
  return (
    !isMarketplace(experiments, tenant) ||
    productVariants
      ?.map(variant => variant.offers)
      .flat()
      .some(offer => {
        return offer.offerType === OFFER_TYPE_SAE
      })
  )
}

export const isLifestyleProduct = (tenant, productTemplate, product) => {
  return (
    tenant === TENANT_COM &&
    productTemplate !== PRODUCT_TEMPLATES.OTX &&
    [LIFESTYLE_PRODUCT.TRUE_WITH_EXCEPTIONS, LIFESTYLE_PRODUCT.TRUE].includes(
      product?.lifestyleProduct
    )
  )
}
